"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaConfigApi = void 0;
const getEcoaConfig = studyId => ({
    method: "GET",
    url: `/studies/${studyId}/ecoa/config`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
exports.ecoaConfigApi = { getEcoaConfig };
//# sourceMappingURL=ecoaConfig.js.map